import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore } from '@alfresco/aca-shared/store';
import { ShowHideFiltersHeaderTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';

@Component({
  selector: 'smt-action-show-filter-header',
  templateUrl: './show-filter-header.component.html'
})
export class ShowFilterHeaderComponent {

  constructor(
    private store: Store<AppStore>,
  ) {}

  showHideFiltersHeaderTable() {
    this.store.dispatch(new ShowHideFiltersHeaderTableAction());
  }
}
